<script setup lang="ts">
import { onMounted, ref } from 'vue';
import Swiper from 'swiper';


type Props = {
    list: any[]
}

const props = withDefaults(defineProps<Props>(), {

})

const swiper = ref<any>(null)
const swiperElt = ref<any>(null);

onMounted(() => {
    swiper.value = new Swiper(swiperElt.value, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: true,
        breakpoints: {
            576: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 2,
                slidesPerGroup: 1,
            },
            992: {
                slidesPerView: 3,
                slidesPerGroup: 1,
            }
        }
    });


})

</script>
<style scoped lang="scss"></style>
<template>
    <div ref="swiperElt" class="swiper projects-swiper">
        <div class="swiper-wrapper">
            <div v-if="props.list.length > 0" v-for="(item, i) in props.list" :key="i" class="swiper-slide" v-css-vars="{
                '--projectColor': `${item.attrs.accentColor}`,
                '--projectLogo': `url(${item.attrs.logo.url})`,
                '--projectBg': `url(${item.attrs.backgroundImage.url})`
            }">
                <a :href="item.url" class="content">
                    <div class="logo">
                        <div class="bg"></div>
                    </div>
                    <div class="technologies">
                        <div class="device" :class="item.attrs.direction"></div>
                    </div>
                    <div class="bottom-popup">
                        <p>{{ item.attrs.description }}</p>
                        <ul>
                            <li v-for="(tech, l) in item.attrs.features" :key="l">
                                {{ tech.name }}
                            </li>
                        </ul>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
